import { render, staticRenderFns } from "./distributorWithdrawDetail.vue?vue&type=template&id=547194a1&"
import script from "./distributorWithdrawDetail.vue?vue&type=script&lang=js&"
export * from "./distributorWithdrawDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports